import React, { useState, useEffect } from 'react';
import { useQuoteStore } from '@/store/quoteStore';
import { Button } from '@/components/ui/button';
import { Ruler, Layers } from 'lucide-react';

const Step1MeasurementType = () => {
  const { measurementType, setMeasurementType, setCurrentStep } = useQuoteStore();
  const [selected, setSelected] = useState(measurementType);

  useEffect(() => {
    setSelected(measurementType);
  }, [measurementType]);

  const handleNext = () => {
    if (selected) {
      setMeasurementType(selected);
      setCurrentStep(2);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8">
      <h2 className="text-2xl md:text-3xl font-bold text-[#27292E] mb-2">
        Measurement Type
      </h2>
      <p className="text-gray-600 mb-8">
        How would you like to enter the measurements of your project?
      </p>

      <div className="space-y-4">
        <div
          className={`border-2 rounded-xl p-6 cursor-pointer transition-all ${
            selected === 'Square metres (m²)'
              ? 'border-[#2F5E96] bg-[#2F5E96]/5'
              : 'border-gray-200 hover:border-[#2F5E96]/50'
          }`}
          onClick={() => setSelected('Square metres (m²)')}
          data-testid="measurement-square-metres"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#2F5E96]/10 rounded-lg flex items-center justify-center">
              <Ruler className="w-6 h-6 text-[#2F5E96]" />
            </div>
            <div>
              <div className="text-lg font-bold text-[#27292E]">Metres Squared</div>
              <div className="text-sm text-gray-500">I&apos;d like the system to calculate my material</div>
            </div>
          </div>
        </div>

        <div
          className={`border-2 rounded-xl p-6 cursor-pointer transition-all ${
            selected === 'Mixes'
              ? 'border-[#2F5E96] bg-[#2F5E96]/5'
              : 'border-gray-200 hover:border-[#2F5E96]/50'
          }`}
          onClick={() => setSelected('Mixes')}
          data-testid="measurement-mixes"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#2F5E96]/10 rounded-lg flex items-center justify-center">
              <Layers className="w-6 h-6 text-[#2F5E96]" />
            </div>
            <div>
              <div className="text-lg font-bold text-[#27292E]">Mixes</div>
              <div className="text-sm text-gray-500">I know the coverage and will enter the mixes required</div>
            </div>
          </div>
        </div>
      </div>

      <Button
        onClick={handleNext}
        disabled={!selected}
        className="w-full mt-8 bg-[#2F5E96] hover:bg-[#254b7a] text-white h-14 text-lg font-bold rounded-xl transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="next-button-step1"
      >
        Next
      </Button>
    </div>
  );
};

export default Step1MeasurementType;